<template>
<div class="onselef" >
  <el-dialog
    :visible.sync="visible"
    width="30%"
    center>
    <p style="text-align: center;font-size: 20px">------ 请选择上车类型 ------</p>
    <span slot="footer" class="dialog-footer">
      <el-button type="primary" plain @click="getCar('合车',3)">自己合车</el-button>
      <el-button type="warning" plain @click="getCar('自己上车',2)">自己上车</el-button>
    </span>
  </el-dialog>
  <quick-page :apps="apps" :show.sync="getCarFlag" :title="onselfForm.remark" :usertype="onselfForm.type"></quick-page>
</div>
</template>

<script>
import quickPage from '@/components/quickPage'
export default {
  name: 'getOneself',
  props: {
    show: {
      type: Boolean,
      default: false
    },
    apps: String
  },
  data () {
    return {
      onselfForm: {
        remark: '',
        type: ''
      },
      loading: false,
      visible: false,
      getCarFlag: false
    }
  },
  computed: {
  },
  watch: {
    show (val) {
      this.visible = val
    },
    visible (val) {
      this.$emit('update:show', val)
    },
    apps: {
      handler (val) {
        this.onselfForm.appId = val
      },
      immediate: true
    }
  },
  created () {
  },
  methods: {
    getCar (str, id) {
      this.getCarFlag = true
      this.onselfForm.type = id
      this.onselfForm.remark = str
    }
  },
  components: {
    quickPage
  }
}
</script>

<style scoped lang="stylus" rel="stylesheet/stylus">
  .onselef
    .unit
      width 85px !important
  .el-autocomplete
    width 100% !important
</style>
